import "../style/header.css"

export default function Header() {
    return (
      <div className="header">  
        <img src="../assets/pictures/logo.png" alt="Toguna - title of the page"/>
      </div>
  )
}
